<p>
  base-input works!
</p>
